export class SeatColors {
    static readonly ON_SALE: string = "548235";
    static readonly ON_SALE_SELECTED: string = "A9D08E";
    static readonly SOLD: string = "204E79";
    static readonly SOLD_SEASONAL: string = "2F75B5";
    static readonly SOLD_GROUP: string = "9BC2E6";
    static readonly COMP: string = "C65911";
    static readonly COMP_SEASONAL: string = "F3B084";
    static readonly RESERVED: string = "FFD966";
    static readonly RESERVED_RSVP: string = "BF8F01";
    static readonly RESERVED_SOCIAL: string = "FFF2CC";
    static readonly PENDING: string = "FF0000";
    static readonly HOLD: string = "FF6B6B";
    static readonly KILL: string = "E6F614";
}


// WEBPACK FOOTER //
// ./src/app/models/seat-colors.ts